import React from "react";
import ReactDOM from "react-dom";
import "./config/api"; // Set axios baseURL for native builds (must be before App)
import App from './App';
import './index.css';

// iOS WebKit throws benign focus() errors inside position:fixed overlays.
// Production builds ignore these, but CRA's dev overlay catches them.
// This suppresses only opaque "Script error." events with no error object.
window.addEventListener("error", (e) => {
  if (e.message === "Script error." && e.error === null) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

ReactDOM.render(<App />, document.getElementById('root'));